import { getCurrentProduct } from "@web/config"
import { useLanguage } from "@web/lib/contexts/language-context"
import { useNavigate } from "react-router"

export function FooterSection() {
  const { t } = useLanguage()
  const { product } = getCurrentProduct()
  const navigate = useNavigate()

  return (
    <footer className="border-t bg-background px-4 py-12">
      <div className="container mx-auto text-center">
        <p className="text-muted-foreground text-sm">
          © {new Date().getFullYear()} {product.name}. {t.footer.copyright}
        </p>
        <div className="mt-2 flex items-center justify-center gap-2 h-20">
          <button
            onClick={() => navigate("/termos-de-uso")}
            className="text-muted-foreground text-sm hover:text-primary cursor-pointer"
          >
            {t.footer.terms}
          </button>
          |
          <button
            onClick={() => navigate("/politica-de-privacidade")}
            className="text-muted-foreground text-sm hover:text-primary cursor-pointer"
          >
            {t.footer.privacy}
          </button>
        </div>
      </div>
    </footer>
  )
}
